import styled from 'styled-components';

export const ComponentWrapper = styled.div`
  position: relative;
  width: 35%;
  margin-top: 100px;
  margin-left: 5%;
  margin-right: 5%;
  float: left
  `;

export const UserNameLabel = styled.label`
  color: #000000;
  text-align: left;
  left: 1%;
  position: relative;
  `;

export const OpinionTextArea = styled.textarea`
  background: #ffffff;
  width: 350px;
  height: 50px;
  position: relative;
  left: 1%;
  border-radius: 7px;
  margin-top: 10px;
  border: 1px solid #ccc;
  box-shadow: 1px 1px 1px #999;
  `;

export const Button = styled.button`
  color: #BF4F74;
  font-size: 1em;
  margin: 5px;
  padding: 0.25em 1em;
  border: 2px solid #BF4F74;
  border-radius: 3px;
`;
 
export const OpinionAreaWrapper = styled.div`
  background: #d9d9d9;
  border-radius: 7px;
  width: 358px;
  height: 102px;
  position: relative;
`; 

